// extracted by mini-css-extract-plugin
module.exports = {"reported-deaths":"reported-deaths___3N1WW","item":"item___2CNxn","highlighted":"highlighted___22To4","name":"name___3vl_2","value":"value___ucvW2"};